"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Import = void 0;
const falconone_1 = require("../../private/api-services/falconone");
const authData_1 = require("../../private/ephemeral/authData");
class Import {
    constructor() {
        if (!(authData_1.Auth.getUserToken())) {
            throw new Error('please use the Authenticator service first');
        }
        this.api = new falconone_1.FalconOne(authData_1.Auth.getUserToken());
    }
    csv(param) {
        return this.api.post('import/property/csv', param, {
            timeout: 999000
        });
    }
}
exports.Import = Import;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1wb3J0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3B1YmxpYy9zZXJ2aWNlcy9pbXBvcnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsb0VBQWlFO0FBQ2pFLCtEQUF3RDtBQUd4RCxNQUFhLE1BQU07SUFHZjtRQUNJLElBQUksQ0FBQyxDQUFDLGVBQUksQ0FBQyxZQUFZLEVBQUUsQ0FBQyxFQUFFO1lBQ3hCLE1BQU0sSUFBSSxLQUFLLENBQUMsNENBQTRDLENBQUMsQ0FBQztTQUNqRTtRQUVELElBQUksQ0FBQyxHQUFHLEdBQUcsSUFBSSxxQkFBUyxDQUNwQixlQUFJLENBQUMsWUFBWSxFQUFFLENBQ3RCLENBQUM7SUFDTixDQUFDO0lBRU0sR0FBRyxDQUFDLEtBQXNCO1FBQzdCLE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQXFCLHFCQUFxQixFQUFFLEtBQUssRUFBRTtZQUNyRSxPQUFPLEVBQUUsTUFBTTtTQUNoQixDQUFDLENBQUM7SUFDUCxDQUFDO0NBQ0o7QUFsQkQsd0JBa0JDIn0=